import React from 'react';
import {
    lazyImport,
    LazyComponent,
    LazySpinner,
} from '../../components/LazyImportComponent';
import { noop } from 'lodash';
import styled from 'styled-components';

const getPhoneVerification = lazyImport(
    () =>
        import(
            /* webpackChunkName: "phone", webpackPrefetch: 30 */ './PhoneVerification'
        ),
    'PhoneVerification'
);

const Spacer = styled.div`
    height: 200px;
    width: 100%;
`;

export const renderPhoneVerificationPage = onComplete => {
    const PhoneVerification = getPhoneVerification();
    return (
        <LazyComponent
            componentName="PhoneVerification"
            fallback={
                <Spacer>
                    <LazySpinner />
                </Spacer>
            }
            onFailure={noop}
        >
            <PhoneVerification
                data-test="phone-verification"
                onComplete={onComplete}
            />
        </LazyComponent>
    );
};
